var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7 9.30035L18.7 2.30035C18.612 2.20264 18.5038 2.1252 18.383 2.0734C18.2621 2.0216 18.1314 1.99668 18 2.00035H8C7.47005 2.00191 6.96224 2.21312 6.58751 2.58786C6.21277 2.9626 6.00156 3.4704 6 4.00036V28.0004C6.00156 28.5303 6.21277 29.0381 6.58751 29.4128C6.96224 29.7876 7.47005 29.9988 8 30.0004H24C24.53 29.9988 25.0378 29.7876 25.4125 29.4128C25.7872 29.0381 25.9984 28.5303 26 28.0004V10.0004C26.0037 9.86891 25.9788 9.73824 25.927 9.61737C25.8752 9.49651 25.7977 9.38834 25.7 9.30035ZM18 4.40036L23.6 10.0004H18V4.40036ZM24 28.0004H8V4.00036H16V10.0004C16.0016 10.5303 16.2128 11.0381 16.5875 11.4128C16.9622 11.7876 17.47 11.9988 18 12.0004H24V28.0004Z",
    fill: "#34373F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankDoc);
export default __webpack_public_path__ + "static/media/BlankDoc.83ec5604087afe4f90583758f51e7aed.svg";
export { ForwardRef as ReactComponent };